import { linkReplace } from '@loomhq/loom-embed';
import { useEffect } from 'react';

import { INLINE_COMMENT_LOOM_VIDEO_SELECTOR } from 'constants/comments';

// replace Loom links with video embeds
export default function useCommentVideoEmbed(ref) {
  useEffect(() => {
    ref.current &&
      linkReplace(INLINE_COMMENT_LOOM_VIDEO_SELECTOR, {}, ref.current);
  }, [ref]);
}
